import React from 'react';
import './MobileHeader.scss';

type MobileHeaderProps = {
    children: React.ReactNode;
};

export default class MobileHeader extends React.Component<MobileHeaderProps> {
    render(): JSX.Element {
        return <div className="mobileHeader">{this.props.children}</div>;
    }
}
